<template lang='pug'>
  auth-layout
    #sign-up.view
      bf-notice(:message='message' @close='message = ""')
      transition
        auth-body(v-show='show' key='auth-body')
          p.betanote(v-if="1==0") {{$t("BlueFaucet is conduction the beta testing. We welcome all the merchants to participate the test.  However, some functions maybe disable during the test. If you have any questions, please contact us at ")}}
            a.email(href='mailto:CS@bluefaucet.com') CS@bluefaucet.com
            span . {{$t("Thank You!")}}.
            
          form.sign-up-form(@submit.prevent='sign_up')
            fieldset
              bf-input
                template(slot='icon')
                  img(src='/ui/email-icon.png')
                input( required type='email' :placeholder='$t("Email")' v-model='email' )

              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( 
                  :placeholder='$t("Password")' 
                  required :type='type'
                  v-model='password' 
                  minlength='8' 
                  title='Must contain at least 1 capital letter and 1 symbol' 
                  pattern='(?=.*?[#?!@$%^&*-+~@])(?=.*[A-Z]).{8,}'
                )
                template(slot='reveal')
                  img(v-if="type=='password'" src='/ui/eyeopen.svg' width="30" @click='showPassword')
                  img(v-else src='/ui/eyeclose.svg' width="30" @click='showPassword')  


              bf-input
                template(slot='icon')
                  img(src='/ui/password-icon.png')
                input( required :type='type' :placeholder='$t("Confirm Password")' v-model='confirm' minlength='8' )

              ol.rule
                li {{$t("Minimum of 8 characters")}}
                li {{$t("At least 1 capital letter and 1 symbol")}}
                li {{$t("A symbol is DEFINED as one of these characters")}}:  * # ? ! @ $ % ^ & * - + ~ @

              bf-input( v-if='referred' )
                template(slot='icon')
                  img(src='/ui/referral-icon.png')
                input( type='text' :placeholder='$t("Referral ID")' v-model='referral.id' :disabled='referred' )

              bf-flex.centered
                bf-button.large.combo.solid.submit(type='submit')
                  template(slot='text') {{ $t('Sign Up') }}

          bf-divider.section.borderless

          .auth-link
            span {{ $t("Already have an account?") }}
            router-link(:to="{ name: 'sign-in', params: {} }") {{ $t("Sign In") }}

          bf-divider.card.borderless

          terms-policy(v-show='show' key='terms-policy')
      auth-body.back-panel(v-show='show' key='back-panel')

</template>

<script>
  import { auth, db } from '@/main'
  import { Authenticable } from '@/mixins/authenticable'
  import AuthLayout from '@/layouts/auth'
  import AuthBody from '@/components/auth-body'
  import TermsPolicy from '@/components/terms-policy'
  import NameIcon from 'vue-material-design-icons/AccountBoxOutline'

  import { Animatable } from '@/mixins/view'

  export default {
    name: 'view.sign-up',

    mixins: [ Animatable ],

    components: {
      AuthLayout,
      AuthBody,
      TermsPolicy,
      NameIcon
    },

    data() {
      return {
        name: '',
        email: '',
        password: '',
        confirm: '',
        message: '',
        referred: !!this.$route.params.id,
        referral: {},
        authenticated: false,
        show: false,
        sluggable: '',
        display: '',
        type: 'password'
      }
    },

    computed: {
      valid() {
        return this.confirm == this.password
      }
    },

    methods: {
      sign_up() {
        const actionSettingCode = { url: 'https://app.bluefaucet.com/' }
        if ( this.valid )
          auth.createUserWithEmailAndPassword( this.email, this.password )
          .then( doc => {
            doc.user.sendEmailVerification(actionSettingCode).then( () => {
              this.$emit( 'sign-up', doc )
            })
          })
          .catch( e => this.message = e )
        else
          this.message = this.$t( 'Password and confirmation does not match!' )
      },
      showPassword() {
        if( this.type == 'password') {
          this.type = 'text'
        } else {
          this.type = 'password'
        }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .email
    color blue
    text-decoration underline
  ol
    font-size .8em
    margin-left 20px
    list-style-type lower-alpha
  .betanote
    padding 10px
    border 1px solid rgb(90 90 90)
    background rgb(240 240 190)
    border-radius 5px
    margin-bottom 20px
    line-height 25px
    font-weight bold
    color red
    
  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background rgba( 25 50 75 .55 )
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    article
      width 320px
      display flex
      flex-direction column
      align-items center
      position relative
      header
        text-align center
        background var(--bg-nav)
        color white
        width 100%
        display flex
        flex-direction column
        align-items center
        padding 24px
        box-sizing border-box
        .logo
          width 150px
          display block
          margin-bottom 32px
      main
        background white
        display flex
        flex-direction column
        align-items center
        padding 24px
        p
          line-height 2

  .bf-button
    margin-top 16px
</style>
